import { getStatusStyle, getStatusLabel } from '../utils/statusColors'

interface StatusBadgeProps {
  status: string | null
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const style = getStatusStyle(status)
  return (
    <span
      className={`inline-flex text-[11px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${style.bg} ${style.text}`}
    >
      {getStatusLabel(status)}
    </span>
  )
}
